import styled from "styled-components";
import colors from "../../../styles/colors";
import fontSizes from "../../../styles/fontSizes";

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Input = styled.input`
  border: 1px solid ${colors.grey};
  font-size: ${fontSizes.large};
  margin-bottom: 0.5rem;
  padding: 0.5rem;
  width: calc(100% - 1.2rem);
`;

export const CheckBox = styled(Input)`
  width: auto;
  margin: 1rem;
`;

export const TextArea = styled.textarea`
  border: 1px solid ${colors.grey};
  font-size: ${fontSizes.large};
  margin-bottom: 0.5rem;
  padding: 0.5rem;
  width: calc(100% - 1.2rem);
`;

export const Select = styled.select`
  border: 1px solid ${colors.grey};
  font-size: ${fontSizes.large};
  margin-bottom: 0.5rem;
  padding: 0.5rem;
  width: calc(100% - 1.2rem);
  color: inherit;
`;

export const NarrowSelect = styled(Select)`
  width: 15rem;
  margin-right: 1rem;
`;

export const Divider = styled.hr`
  background-color: ${colors.lightsilver};
  width: 100%;
  height: 0.1rem;
  border: none;
`;
